import validate from 'jquery-validation';
validate;

function setupContact() {
    $(".contact-language-form input[name='phone']").mask('(00) 00000-0000');

    $('.contact-language-form').validate({
        onFocusOut: true,
        focusInvalid: false,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.contact-language-form .errors',
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
                minlength: 8,
            },
            message: 'required',
            fl_age: 'required',
            fl_privacy: 'required',
        },
        messages: {
            name: 'O campo "Nome" não foi preenchido',
            email: {
                required: 'O campo "Email" não foi preenchido',
                email: 'Digite um "Email" válido',
            },
            phone: {
                required: 'O campo "Telefone" não foi preenchido',
                minlength: 'Digite um "Telefone" válido',
            },
            message: 'O campo "Mensagem" não foi preenchido',
            fl_age: 'Você precisa confirmar que tem 18 anos ou mais.', //TODO: texto
            fl_privacy: 'Você precisa confirmar se esta de acordo com a coleta de dados.', //TODO: texto
        },
        invalidHandler: function () {
            $('.contact-language-form .btn-submit').removeClass('loading');
            $('.contact-language-form .success').empty();
        },
        submitHandler: function (form, event) {
            if ($('.contact-language-form .btn-submit').hasClass('loading')) {
                return;
            }

            $('.contact-language-form .btn-submit').addClass('loading');

            event.preventDefault();
            event.stopPropagation();

            $.ajax({
                type: 'POST',
                url: $(form).data('action'),
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (data) {
                    form.reset();
                    $('.contact-language-form .success').html(data);
                    $('.contact-language-form .btn-submit').removeClass('loading');
                },
                error: function (data) {
                    $('.contact-language-form .success').empty();
                    $('.contact-language-form .btn-submit').removeClass('loading');

                    if (data.responseJSON || data.responseText) {
                        $('.contact-language-form .errors')
                            .html(
                                data.responseJSON && data.responseJSON.errors
                                    ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                                    : data.responseJSON.message || data.responseText
                            )
                            .show({ duration: 0 });
                    }

                    try {
                        reloadCaptcha('contact');
                    } catch (e) {
                        console.log(e);
                    }
                },
            });
        },
    });
}

function testContact() {
    $("input[name='name']").val('Lorem Ipsun');
    $("input[name='email']").val('teste@test.com');
    $("input[name='phone']").val('54 000000000');
    $("textarea[name='message']").val('Lorem ipsun dolor');
    $("input[name='fl_age']").attr('checked', 'checked');
    $("input[name='fl_privacy']").attr('checked', 'checked');
    $("input[name='fl_newsletter']").attr('checked', 'checked');
}

function initialize() {
    setupContact();
}

initialize();
